import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["focus-group"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createElementVNode("div", {
    class: "fixed z-500 outline-none animate-dropdown flex",
    "focus-group": this.useFocusGroup ?? 'default-focus-group',
    tabindex: "0",
    style: _normalizeStyle(this.style),
    ref: "element"
  }, [_renderSlot(_ctx.$slots, "default", {
    id: "slot"
  })], 12, _hoisted_1)]);
}